import React from "react";
class Duedates extends React.Component {
  render() {
    return (
      <div>
        <section>
          <div className="row">
            <div className="col-md-3">
              <div className="panel panel-default">
                <div className="panel-heading" role="tab" id="headingeight">
                  <h4 className="panel-title">
                    <a
                      className="collapsed seccccc"
                      role="button"
                      data-toggle="collapse"
                      data-parent="#accordion"
                      href="#collapseeight"
                      aria-expanded="false"
                      aria-controls="collapseeight"
                    >
                      Collapsible Group Item #5
                      <i
                        className="fa fa-chevron-down float-right"
                        aria-hidden="true"
                      ></i>
                    </a>
                  </h4>
                </div>
                <div
                  id="collapseeight"
                  className="panel-collapse collapse"
                  role="tabpanel"
                  aria-labelledby="headingeight"
                >
                  <div className="panel-body">
                    Anim pariatur cliche reprehenderit, enim eiusmod high life
                    accusamus terry richardson ad squid. 3 wolf moon officia
                    aute, non cupidatat skateboard dolor brunch. Food truck
                    quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor,
                    sunt aliqua put a bird on it squid single-origin coffee
                    nulla assumenda shoreditch et. Nihil anim keffiyeh
                    helvetica, craft beer labore wes anderson cred nesciunt
                    sapiente ea proident. Ad vegan excepteur butcher vice lomo.
                    Leggings occaecat craft beer farm-to-table, raw denim
                    aesthetic synth nesciunt you probably haven't heard of them
                    accusamus labore sustainable VHS.
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="panel panel-default">
                <div className="panel-heading" role="tab" id="headingnine">
                  <h4 className="panel-title">
                    <a
                      className="collapsed seccccc"
                      role="button"
                      data-toggle="collapse"
                      data-parent="#accordion"
                      href="#collapsenine"
                      aria-expanded="false"
                      aria-controls="collapsenine"
                    >
                      Collapsible Group Item #5
                      <i
                        className="fa fa-chevron-down float-right"
                        aria-hidden="true"
                      ></i>
                    </a>
                  </h4>
                </div>
                <div
                  id="collapsenine"
                  className="panel-collapse collapse"
                  role="tabpanel"
                  aria-labelledby="headingnine"
                >
                  <div className="panel-body">
                    Anim pariatur cliche reprehenderit, enim eiusmod high life
                    accusamus terry richardson ad squid. 3 wolf moon officia
                    aute, non cupidatat skateboard dolor brunch. Food truck
                    quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor,
                    sunt aliqua put a bird on it squid single-origin coffee
                    nulla assumenda shoreditch et. Nihil anim keffiyeh
                    helvetica, craft beer labore wes anderson cred nesciunt
                    sapiente ea proident. Ad vegan excepteur butcher vice lomo.
                    Leggings occaecat craft beer farm-to-table, raw denim
                    aesthetic synth nesciunt you probably haven't heard of them
                    accusamus labore sustainable VHS.
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="panel panel-default">
                <div className="panel-heading" role="tab" id="headingeight">
                  <h4 className="panel-title">
                    <a
                      className="collapsed seccccc"
                      role="button"
                      data-toggle="collapse"
                      data-parent="#accordion"
                      href="#collapseeight"
                      aria-expanded="false"
                      aria-controls="collapseeight"
                    >
                      Collapsible Group Item #5
                      <i
                        className="fa fa-chevron-down float-right"
                        aria-hidden="true"
                      ></i>
                    </a>
                  </h4>
                </div>
                <div
                  id="collapse"
                  className="panel-collapse collapse"
                  role="tabpanel"
                  aria-labelledby="headingeight"
                >
                  <div className="panel-body">
                    Anim pariatur cliche reprehenderit, enim eiusmod high life
                    accusamus terry richardson ad squid. 3 wolf moon officia
                    aute, non cupidatat skateboard dolor brunch. Food truck
                    quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor,
                    sunt aliqua put a bird on it squid single-origin coffee
                    nulla assumenda shoreditch et. Nihil anim keffiyeh
                    helvetica, craft beer labore wes anderson cred nesciunt
                    sapiente ea proident. Ad vegan excepteur butcher vice lomo.
                    Leggings occaecat craft beer farm-to-table, raw denim
                    aesthetic synth nesciunt you probably haven't heard of them
                    accusamus labore sustainable VHS.
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="panel panel-default">
                <div className="panel-heading" role="tab" id="headingfive">
                  <h4 className="panel-title">
                    <a
                      className="collapsed seccccc"
                      role="button"
                      data-toggle="collapse"
                      data-parent="#accordion"
                      href="#collapsefive"
                      aria-expanded="false"
                      aria-controls="collapsefive"
                    >
                      Collapsible Group Item #5
                      <i
                        className="fa fa-chevron-down float-right"
                        aria-hidden="true"
                      ></i>
                    </a>
                  </h4>
                </div>
                <div
                  id="collapsefive"
                  className="panel-collapse collapse"
                  role="tabpanel"
                  aria-labelledby="headingfive"
                >
                  <div className="panel-body">
                    Anim pariatur cliche reprehenderit, enim eiusmod high life
                    accusamus terry richardson ad squid. 3 wolf moon officia
                    aute, non cupidatat skateboard dolor brunch. Food truck
                    quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor,
                    sunt aliqua put a bird on it squid single-origin coffee
                    nulla assumenda shoreditch et. Nihil anim keffiyeh
                    helvetica, craft beer labore wes anderson cred nesciunt
                    sapiente ea proident. Ad vegan excepteur butcher vice lomo.
                    Leggings occaecat craft beer farm-to-table, raw denim
                    aesthetic synth nesciunt you probably haven't heard of them
                    accusamus labore sustainable VHS.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
export default Duedates;
